import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { me } from '../api/portal';
import { parseHandoffHash, writeImpersonation } from '../lib/impersonation';
import { useAuthStore } from '../stores/auth';

export function HandoffPage() {
  const nav = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const payload = parseHandoffHash();
    if (!payload) {
      setErr('Missing handoff token. Go back to admin and try Open portal again.');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        setSession(payload.access_token, payload.expires_at, {
          id: '',
          company_name: payload.label,
          contact_email: '',
          tier: '',
        });
        const profile = await me();
        if (cancelled) return;
        setSession(payload.access_token, payload.expires_at, profile);
        writeImpersonation({
          actor: payload.actor,
          label: payload.label,
          kind: payload.kind || 'client',
          return_url: payload.return_url,
        });
        window.history.replaceState(null, '', '/matches');
        nav('/matches', { replace: true });
      } catch (e: unknown) {
        if (!cancelled) setErr(e instanceof Error ? e.message : 'Handoff failed');
      }
    })();
    return () => { cancelled = true; };
  }, [nav, setSession]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-base px-4 text-[13px] text-slate-300">
      {err ?? 'Signing you in…'}
    </div>
  );
}
